import { useEffect, useState } from "react";

/**
 * Returns `value` delayed by `delayMs`. Resets the timer on every change —
 * used by the search modal so we hit the API once the user stops typing
 * rather than on every keystroke.
 */
export function useDebouncedValue<T>(value: T, delayMs = 150): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const t = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(t);
  }, [value, delayMs]);

  return debounced;
}
